export const MIN_SCORE_OPTIONS = [
  { value: 0, label: '0 (no limit)' },
  ...Array.from({ length: 10 }, (_, i) => {
    const v = -(i + 1) * 100;
    return { value: v, label: String(v) };
  }),
];

export const MAX_SCORE_OPTIONS = Array.from({ length: 10 }, (_, i) => {
  const v = (i + 1) * 100;
  return { value: v, label: String(v) };
});

export const VARIANT_OPTIONS = [
  { value: 'teams', label: 'Teams (standard)' },
  { value: 'singles', label: 'Singles (standard)' },
];

export const BAG_PRESETS = [
  { id: '10-100', label: '10 = −100', bagLimit: 10, bagPenalty: 100 },
  { id: '5-50', label: '5 = −50', bagLimit: 5, bagPenalty: 50 },
  { id: '10-200', label: '10 = −200', bagLimit: 10, bagPenalty: 200 },
  { id: '7-70', label: '7 = −70', bagLimit: 7, bagPenalty: 70 },
];

export function bagPresetId(settings) {
  const match = BAG_PRESETS.find(
    (p) => p.bagLimit === settings?.bagLimit && p.bagPenalty === settings?.bagPenalty,
  );
  return match?.id || '10-100';
}

export function formatLossLimit(autoLossAt) {
  return autoLossAt === 0 ? 'No limit' : String(autoLossAt);
}